export default __webpack_public_path__ + "static/media/tshirt3.686ed0b2.png";